// extracted by mini-css-extract-plugin
export default {"mCard":"OE-z","image":"PE-z","imageNoBackground":"QE-z","imageHasCategory":"RE-z","fullWidth":"SE-z"};